import { X } from 'lucide-react';

import { KubesoloTest } from '@api/types.gen';

import { LoadingButton } from '@@/buttons/LoadingButton';

import { isInProgress } from '../queries/useActiveConnectionTest';
import { useClearConnectionTestMutation } from '../queries/useClearConnectionTestMutation';

export function ClearTestButton({ test }: { test: KubesoloTest }) {
  const clearMutation = useClearConnectionTestMutation();
  const inProgress = isInProgress(test);

  return (
    <LoadingButton
      color={inProgress ? 'dangerlight' : 'default'}
      icon={X}
      isLoading={clearMutation.isLoading}
      loadingText={inProgress ? 'Cancelling...' : 'Clearing...'}
      onClick={() => clearMutation.mutate(test.id)}
      type="button"
      data-cy="kubesolo-clear-test-button"
    >
      {inProgress ? 'Cancel test' : 'Clear results'}
    </LoadingButton>
  );
}
